/*******************************************************************************/
/* Imports
/*******************************************************************************/

import React from 'react';

import { Input } from '@commandbar/design-system/components/antd';
import { CmdButton } from '@commandbar/design-system/cmd';
import { Check, Plus, X } from '@commandbar/design-system/icons/react';
import TextAreaWithInterpolation from '../../../components/TextAreaWithInterpolation';

/*******************************************************************************/

const NewObjectForm = (props: {
  onCreate: (toAdd: string) => void;
  buttonText: string | null;
  placeholderText: string;
  autocomplete?: boolean;
}) => {
  const [isActive, setActive] = React.useState(false);

  const onSave = (newVal: string) => {
    setActive(false);
    props.onCreate(newVal);
  };

  if (!isActive && props.buttonText) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <CmdButton
          onClick={() => {
            setActive(true);
          }}
          icon={<Plus />}
        >
          {props.buttonText}
        </CmdButton>
      </div>
    );
  }

  return (
    <SaveInput
      placeholder={props.placeholderText}
      onSave={onSave}
      defaultValue={undefined}
      onCancel={() => {
        setActive(false);
      }}
      autocomplete={props.autocomplete}
    />
  );
};

export class SaveInput extends React.Component<
  {
    onSave: (newVal: string) => void;
    placeholder?: string;
    defaultValue?: string;
    onCancel: () => void;
    autocomplete?: boolean;
  },
  { value: string }
> {
  public constructor(props: any) {
    super(props);
    this.state = {
      value: props.defaultValue || '',
    };
  }

  public render() {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {this.props.autocomplete ? (
          <div style={{ width: '100%' }}>
            <TextAreaWithInterpolation
              onChange={(value) => {
                this.setState({ value });
              }}
              value={this.state.value}
              placeholder={this.props.placeholder}
            />
          </div>
        ) : (
          <Input
            onPressEnter={() => this.props.onSave(this.state.value || '')}
            value={this.state.value}
            defaultValue={this.props.defaultValue}
            placeholder={this.props.placeholder}
            onChange={(e) => {
              this.setState({ value: e.target.value });
            }}
            autoFocus={true}
          />
        )}
        <CmdButton icon={<Check />} variant="ghost" onClick={() => this.props.onSave(this.state.value || '')} />
        <CmdButton icon={<X />} variant="ghost" onClick={this.props.onCancel} />
      </div>
    );
  }
}

export default NewObjectForm;
